import React from 'react';
import PropTypes from 'prop-types';
import styles from './Note.module.scss';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import classNames from 'classnames';

const Note = (props) => {
  return (
    <div className={classNames(styles.sub, styles[props.type])}>
      <InfoOutlinedIcon />
      <span>{props.text}</span>
    </div>
  );
};

Note.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(['default', 'info', 'warning', 'danger', 'success'])
};

Note.defaultProps = {
  text: '',
  type: 'default'
};

export default Note;
